import React from "react";
import { CircularProgress, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CircleProgressBar = ({
  progress = 0,
  size = 20,
  onClick,
  disabled = false,
}) => {
  const handleClick = (e) => {
    if (!disabled && typeof onClick === "function") {
      e.stopPropagation(); // Prevents click from bubbling up
      onClick(e);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "default" : "pointer",
      }}
      onClick={handleClick}
    >
      {/* Background circle */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        sx={{
          color: "#999999",
          position: "absolute",
        }}
      />

      {/* Foreground progress circle */}
      <CircularProgress
        variant="determinate"
        value={progress}
        size={size}
        sx={{
          //color: progress === 100 ? "green" : "primary.main",
          position: "absolute",
        }}
      />

      {/* Center checkmark */}
      {progress === 100 && (
        <CheckCircleIcon
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "primary.main",
            fontSize: size,
          }}
        />
      )}
    </Box>
  );
};

export default CircleProgressBar;
